export const state = () => ({
    entity: '',
})

export const mutations = {
    setEntity(state, obj) {
        state.entity = obj
    },
}
